import { AxiosPromise, AxiosResponse } from 'axios';
import Http from '../../shared/http';
import { ServerResponse, WithAuditDetails } from '../types';
import {
  ActiveAlarm,
  API_PATH_ACTIVE_ALARMS,
  API_PATH_HISTORICAL_ALARMS,
  API_PATH_SUPPRESSED_ALARMS,
  API_PATH_UNSUPPRESSED_ALAMRS,
  HistoricalAlarm,
  SuppressedAlarm
} from './alarm.types';

const http = Http.getHttp();

export const MOCK_ACTIVE_ALARMS: ServerResponse<ActiveAlarm> = {
  success: true,
  metadata: {
    recordsInView: 2,
    recordCount: 2,
    idCreated: '',
    uriStatus: null
  },
  data: [
    {
      alarmid: '0x1800ef16',
      instance: 'iribuf_1',
      level: 'CRITICAL',
      module: 18,
      number: 2,
      ss8group: 'LIS',
      count: 49205,
      text: 'LIS: Message',
      date: '09/24/2024',
      time: '10:05:51'
    },
    {
      alarmid: '0x1800ef17',
      instance: 'iribuf_1',
      level: 'CRITICAL',
      module: 18,
      number: 2,
      ss8group: 'LIS',
      count: 49205,
      text: 'LIS: Message',
      date: '09/24/2024',
      time: '10:05:51'
    }
  ],
  error: null
};

export const MOCK_SUPPRESSED_ALARMS: ServerResponse<SuppressedAlarm> = {
  success: true,
  metadata: {
    recordsInView: 2,
    recordCount: 2,
    idCreated: '',
    uriStatus: null
  },
  data: [
    {
      alarmid: '0x1800ef16',
      level: 'INFO',
      instance: 'SNMPTRAPGEN',
      text: 'LIS: SNMPTRAPGEN: Module Started Successfully.',
      date: '2024-11-25',
      time: '16:00:59',
      module: 1,
      number: 1,
      almGroupId: 'LIS',

    },
    {
      alarmid: '0x1800ed01',
      level: 'INFO',
      instance: 'PCRIPQAFPIM',
      text: 'LIS: PCRIPQAFPIM: Registered to SPM',
      date: '2024-11-25 16:04:05',
      time: '16:00:59',
      module: 16,
      number: 2,
      almGroupId: 'LIS',
    }
  ],
  error: null
};

export const MOCK_HISTORICAL_ALARMS: ServerResponse<HistoricalAlarm> = {
  success: true,
  metadata: {
    recordsInView: 2,
    recordCount: 2,
    idCreated: '',
    uriStatus: null
  },
  data: [
    {
      alarmid: '0x1800ed01',
      level: 'INFO',
      source: 'SNMPTRAPGEN',
      message: 'LIS: SNMPTRAPGEN: Module Started Successfully.',
      datetime: '2024-11-19 13:51:28',
      src_host: 'xcpTest-sumanth-135-51'
    },
    {
      alarmid: '0x1800ee01',
      level: 'INFO',
      source: 'XCBWMGR',
      message: 'LIS: XCBWMGR: Module Started Successfully.',
      datetime: '2024-11-19 13:51:29',
      src_host: 'xcpTest-sumanth-135-51'
    }
  ],
  error: null
};

export function getActiveAlarms(
  requestParams: string
): AxiosPromise<ServerResponse<ActiveAlarm>> {
  return http.get(`${API_PATH_ACTIVE_ALARMS}?${requestParams}`);
}

export function getSuppressedAlarms(requestParams: string): AxiosPromise<
  ServerResponse<SuppressedAlarm>
> {
  return http.get(`${API_PATH_SUPPRESSED_ALARMS}?${requestParams}`);
}

export function getHistoricalAlarms(requestParams: string): AxiosPromise<
  ServerResponse<HistoricalAlarm>
> {
  return http.get(`${API_PATH_HISTORICAL_ALARMS}?${requestParams}`);
}

export function suppressedAlarms(
  body: WithAuditDetails<SuppressedAlarm[]>
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_SUPPRESSED_ALARMS}`, body);
}

export function deleteSuppressedAlarms(
  body: WithAuditDetails<SuppressedAlarm[]>
): AxiosPromise<ServerResponse<void>> {
  return http.post(`${API_PATH_UNSUPPRESSED_ALAMRS}`, body);
}
